import { render, staticRenderFns } from "./ListarObraSocial.vue?vue&type=template&id=d872873c&"
import script from "./ListarObraSocial.vue?vue&type=script&lang=js&"
export * from "./ListarObraSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports